export const lightenColor = (color: string, percent: number): string => {
  let r: number
  let g: number
  let b: number
  let a = 1

  // Handle HEX format
  if (color.startsWith('#')) {
    // Convert hex to RGB
    let hex = color.replace('#', '')
    if (hex.length === 3 && hex.match(/[0-9A-Fa-f]{3}/)) {
      hex = hex
        .split('')
        .map(char => char + char)
        .join('')
    }
    if (hex.length !== 6) throw new Error('Invalid HEX color.')
    r = parseInt(hex.substring(0, 2), 16)
    g = parseInt(hex.substring(2, 4), 16)
    b = parseInt(hex.substring(4, 6), 16)
  }
  // Handle RGBA format
  else if (color.startsWith('rgba')) {
    const rgbaMatch = color.match(
      /rgba?\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/
    )
    if (!rgbaMatch) throw new Error('Invalid RGBA color format.')
    ;[r, g, b, a] = rgbaMatch.slice(1).map(Number) as [
      number,
      number,
      number,
      number
    ]
  }
  // Handle RGB format
  else if (color.startsWith('rgb')) {
    const rgbMatch = color.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/)
    if (!rgbMatch) throw new Error('Invalid RGB color format.')
    ;[r, g, b] = rgbMatch.slice(1).map(Number) as [number, number, number]
  } else {
    throw new Error(
      'Invalid color format. Accepted formats are HEX, RGB, and RGBA.'
    )
  }

  // Function to lighten a single color component
  const lighten = (component: number): number =>
    Math.min(255, Math.floor(component + (255 - component) * (percent / 100)))

  // Apply the lighten function to each component
  r = lighten(r)
  g = lighten(g)
  b = lighten(b)

  // Return the result in the same format as input
  return a < 1 ? `rgba(${r}, ${g}, ${b}, ${a})` : `rgb(${r}, ${g}, ${b})`
}
